import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core'
import { useCallback } from 'react'
import { useSelectedColumnsContext } from '../../../../SelectedColumnsProvider'

type PageSelectorProps = {
  pageCount: number
  pageNumber: number
  updateSelectedPageNumber: (page: number) => void
}

export default function PageSelector({
  pageCount,
  pageNumber,
  updateSelectedPageNumber,
}: PageSelectorProps) {
  const pages = useCallback(
    () => Array.from(Array(pageCount).keys()),
    [pageCount],
  )
  const { pageToSelectedColumns } = useSelectedColumnsContext()
  return (
    <FormControl>
      <InputLabel id='page-label'>Page</InputLabel>
      <Select
        id='page-label-select'
        value={pageNumber}
        color='secondary'
        onChange={(e) => updateSelectedPageNumber(e.target.value as number)}
      >
        {pages().map((i) => {
          const pageValue = i + 1;
          const isHighlighted = pageToSelectedColumns.has(pageValue);

          return (
            <MenuItem
              value={pageValue}
              key={i}
              style={{
                backgroundColor: isHighlighted ? 'rgba(74, 144, 226, 0.5)' : 'inherit',
                color: isHighlighted ? 'white' : 'inherit',
              }}
            >
              {pageValue}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  )
}
